<template>
  <div>
    <section class="hero is-primary is-medium">
      <div class="hero-body">
        <div class="container">
          <h1 class="title is-1">
            Partners and Community
          </h1>
          <h2 class="subtitle is-4">
            Creating Accessible Solutions
          </h2>
        </div>
      </div>
    </section>

    <section class="section has-text-centered">
      <div class="container">
        <h2 class="title">
          Tech Partners
        </h2>
        <p>
          We're always looking for new partners in the tech community and the deaf community. Please contact us to get involved!
        </p>
        <br>
        <div class="button-container">
          <a
            href="mailto:info@beatcaps.io"
            class="button is-medium is-inverted is-rounded is-outlined has-text-weight-bold"
            style="border: 0.15em solid black;"
          >Contact Us</a>
        </div>

        <partner-logos label-classes="has-text-black" />
      </div>
    </section>

    <section>
      <div class="section has-background-light">
        <div class="container">
          <div class="columns">
            <div class="column is-two-thirds">
              <h3 class="title is-3">
                Deaf Community
              </h3>
              <h4 class="title is-4">
                Non-Profit Shout Outs
              </h4>
              <p class="block">
                We had reached out to <a href="https://deafculturecentre.ca/"><strong>Deaf Culture Center</strong></a> of ON, CAN early 2020 and they have since partnered with us and inspired us to grow our video editing tools to include PIP for the Deaf, an integral part of who we have become. Please check them out at: <a href="https://deafculturecentre.ca/">https://deafculturecentre.ca/</a>
              </p>
              <p class="block">
                Late 2020 <a href="http://www.deafteched.org/"><strong>Deaf Tech Ed</strong></a> of CA, USA had reached out to us for interest in out PIP software and while our relationship is still new, we are grateful for their time so far and look forward to helping each other out more in 2021. Please check them out at: <a href="http://www.deafteched.org/">http://www.deafteched.org/</a>
              </p>
            </div>
            <img
              src="/img/cellphone-with-headphones.jpg"
              alt=""
              class="column is-one-third"
            >
          </div>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <h4 class="title is-4">
            Further Readings/Statistics
          </h4>
          <h5 class="title is-5">
            Sign Language
          </h5>
          <ul class="block">
            <li>
              <a href="http://cad.ca/issues-positions/language">Canadian Association for the Deaf - <em>"Language"</em></a>
            </li>
            <li>
              <a href="https://www.linguisticsociety.org/content/what-sign-language">Linguistics Society - <em>"What is sign language?"</em></a>
            </li>
          </ul>
          <h5 class="title is-5">
            ASL (American Sign Language)
          </h5>
          <ul class="block">
            <li>
              <a href="https://www.nad.org/resources/american-sign-language/what-is-american-sign-language/">National Association of the Deaf - <em>"What is American Sign Language?"</em></a>
            </li>
            <li>
              <a href="https://www.nidcd.nih.gov/health/american-sign-language">National Institute on Deafness and Other Communication Disorders (NIDCD) - <em>"American Sign Language"</em></a>
            </li>
          </ul>
          <div class="block">
            <h5 class="title is-5">
              World Statistics
            </h5>
            <p>Did you know? 466 Million people world wide have disabling hearing loss, that's over 5% of the worlds population.</p>
            <a href="https://www.who.int/news-room/fact-sheets/detail/deafness-and-hearing-loss">World Health Organization - <em>"Deafness and Hearing Loss"</em></a>
          </div>
          <div class="block">
            <h5 class="title is-5">
              American Statistics
            </h5>
            <p>Did you know? 1/8 Americans over 12 have hearing loss in both ears.</p>
            <a href="https://www.nidcd.nih.gov/health/statistics/quick-statistics-hearing">National Institute on Deafness and Other Communication Disorders (NIDCD) - <em>"Quick Statistics"</em></a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PartnerLogos from '../components/PartnerLogos.vue'

export default {
  name: 'AboutPage',
  components: { PartnerLogos },
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {
    this.$emit('theme', 'dark')
  }
}
</script>
